"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var qrcode_vue_1 = require("qrcode.vue");
var vue_property_decorator_1 = require("vue-property-decorator");
var account = "CZ2620100000002200503306";
var QrCodeCust = /** @class */ (function (_super) {
    __extends(QrCodeCust, _super);
    function QrCodeCust() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.roundedAmount = "";
        _this.paymentString = "";
        return _this;
    }
    QrCodeCust.prototype.mounted = function () {
        this.generatePaymentString();
    };
    QrCodeCust.prototype.generatePaymentString = function () {
        this.roundedAmount = this.amount.toFixed(2).toString();
        this.paymentString = "SPD*1.0*ACC:" + account + "*AM:" + this.roundedAmount + "*CC:CZK**MSG:" + this.name + "*X-SS:" + this.specSymbol + "*X-VS:" + this.varSymbol;
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], QrCodeCust.prototype, "varSymbol", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], QrCodeCust.prototype, "amount", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], QrCodeCust.prototype, "name", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], QrCodeCust.prototype, "specSymbol", void 0);
    __decorate([
        vue_property_decorator_1.Watch("varSymbol"),
        vue_property_decorator_1.Watch("amount")
    ], QrCodeCust.prototype, "generatePaymentString", null);
    QrCodeCust = __decorate([
        vue_property_decorator_1.Component({ components: { QrcodeVue: qrcode_vue_1.default } })
    ], QrCodeCust);
    return QrCodeCust;
}(vue_1.default));
exports.default = QrCodeCust;
